module.exports = ":host mat-card-title {\n  text-align: center; }\n\n:host .footer {\n  margin-top: 1.5rem; }\n"